import '/assets/js/common.js';
import '/assets/css/_common.scss';
import '/assets/css/ir-annualreport.scss';